import React, { useState, useEffect } from "react";
import {
  Link,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { Toast } from "../../Components";
import { motion } from "framer-motion";
import { accountService, alertService } from "../../Services";
import { utils } from "../../Helpers/utils";
import Parser from "html-react-parser";




const initForm = {
  email: "",
  password: "",
};

export default function Login({ setModal, referPageUrl }) {
  const [form, setForm] = useState(initForm);
  const [error, setError] = useState(false);
  const [isLinkVerified, setIsLinkVerified] = useState(false);
  const [verificationMessage, setVerificationMessage] = useState("");
  const [toastList, setToastList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [isLoginWithEmail, setIsLoginWithEmail] = useState(false);
  const [showSignupPopup, setShowSignupPopup] = useState(false);

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const validateId = searchParams.get("validateId");
  const errorParam = searchParams.get("error");

  // process.env.PUBLIC_URL}/images/trusted.png
  // process.env.PUBLIC_URL}/images/high_performance.png
  // process.env.PUBLIC_URL}/images/powerd_by_data.png
  // process.env.PUBLIC_URL}/images/recommended.png
  // process.env.PUBLIC_URL}/images/responsible_ai.png

  useEffect(() => {
    localStorage.clear();
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href =
      "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css";
    link.crossOrigin = "anonymous";
    link.referrerPolicy = "no-referrer";
    document.head.appendChild(link);

    return () => {
      document.head.removeChild(link);
    };
  }, []);

  const updateForm = (data) => setForm((prev) => ({ ...prev, ...data }));
  const setInput = (key) => (e) => updateForm({ [key]: e.target.value });

  useEffect(() => {
    if (errorParam) {
      const errorMsg =
        errorParam === "1"
          ? Parser(
              "Please <a className='paidLink' href='/#/account/signup'> click here </a> to signup"
            )
          : errorParam === "2"
          ? Parser("Not have enough permission to login")
          : "";

      if (errorMsg) {
        addToast({
          error: true,
          msg: errorMsg,
          id: `${Date.now()}-${toastList.length}`,
        });
      }
    }
    // eslint-disable-next-line 
  }, [errorParam]);

  const pathurl =
    referPageUrl?.state?.pathname &&
    referPageUrl?.pathname !== "/account/validateEmail"
      ? referPageUrl.state.pathname.includes("/brand/influencerProfile/")
        ? referPageUrl.state.pathname.slice(1)
        : referPageUrl.state.pathname
      : "";

  const loginRedirect = (res) => {
    const activeRole = res.data.active_role;
    const roles = res["data"]?.["roles"];
    const arrPath = referPageUrl?.state?.pathname?.split("/") || [];
    if (roles?.[0]?.id === 1 && activeRole === 1) {
      return arrPath[1] === "influencer"
        ? referPageUrl.state.pathname
        : utils.redirectUrl(res.profilestatus)[0];
    } else if (activeRole === 3) {
      return arrPath[1] === "brand"
        ? referPageUrl.state.pathname
        : "/brand/dashboard";
    } else if (activeRole === 2) {
      return arrPath[1] === "admin"
        ? referPageUrl.state.search
          ? referPageUrl.state.pathname + referPageUrl.state.search
          : referPageUrl.state.pathname
        : "/admin/dashboard";
    }
    return "/account/login";
  };

  const loginValidation = () => {
    if (!form.email || !form.password) return setError(true);

    alertService.clear();
    setLoading(true);
    accountService
      .login(form.email, form.password)
      .then((res) => {
        if (res.data?.data?.roles) {
          navigate(loginRedirect(res.data));
        } else if (
          res.isEmailVerified === false &&
          res.reason === "resendverification"
        ) {
          navigate("/account/validateEmail", {
            state: {
              email: res.data.email,
              userId: res.data.id,
              reason: res.reason,
            },
          });
        } else {
          navigate("/account/login");
        }
      })
      .catch((err) => {
        addToast({
          error: true,
          msg: typeof err === "string" ? err : err || "Login failed",
          id: `${Date.now()}-${toastList.length}`,
        });
      })
      .finally(() => setLoading(false));
  };

  const addToast = (toast) =>
    setToastList((prev) => [
      ...prev,
      { ...toast, id: `${Date.now()}-${prev.length}` },
    ]);

  useEffect(() => {
    const validateEmailLink = async () => {
      if (!validateId) return setIsLinkVerified(true);

      try {
        const res = await accountService.validateEmail(validateId);
        if (res.isEmailVerified) {
          setVerificationMessage("Thank You. Email is verified.");
          setIsLinkVerified(true);
        } else {
          const state =
            res.reason === "expired" || res.reason === "unverified"
              ? { userId: res.data?.id || "", reason: res.reason }
              : null;
          navigate("/account/validateEmail", { state });
        }
      } catch (err) {
        addToast({ error: true, date: new Date(), msg: err });
      }
    };
    validateEmailLink();
    // eslint-disable-next-line 
  }, [validateId]);

  useEffect(() => {
    const keyDownHandler = (e) => e.key === "Enter" && isLoginWithEmail && loginValidation();
    document.addEventListener("keydown", keyDownHandler);
    return () => document.removeEventListener("keydown", keyDownHandler);
    // eslint-disable-next-line 
  }, [form, isLoginWithEmail]);

  const socialLogin = (provider) => {
    window.location.href = `${process.env.REACT_APP_API_URL}/login/${provider}/action/signin/role/1/0/referalPath/${pathurl}`;
  };

  // Social login icons
  const FacebookIcon = () => (
    <svg className="w-6 h-6" viewBox="0 0 24 24">
      <path fill="#1877F2" d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
    </svg>
  );

  const InstagramIcon = () => (
    <svg className="w-6 h-6" viewBox="0 0 24 24">
      <defs>
        <linearGradient id="instagram-gradient" x1="0%" y1="100%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#FFDC80"/>
          <stop offset="25%" stopColor="#F77737"/>
          <stop offset="50%" stopColor="#E1306C"/>
          <stop offset="75%" stopColor="#C13584"/>
          <stop offset="100%" stopColor="#833AB4"/>
        </linearGradient>
      </defs>
      <path fill="url(#instagram-gradient)" d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
    </svg>
  );

  const TikTokIcon = () => (
    <svg className="w-6 h-6" viewBox="0 0 24 24">
      <path fill="#000000" d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z"/>
    </svg>
  );

  const GoogleIcon = () => (
    <svg className="w-6 h-6" viewBox="0 0 24 24">
      <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
      <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
      <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
      <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
    </svg>
  );

  const EmailIcon = () => (
    <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <rect x="2" y="4" width="20" height="16" rx="2" className="stroke-gray-600"/>
      <path d="M22 6L12 13L2 6" className="stroke-gray-600"/>
    </svg>
  );

  // Logo component with green gradient theme
  const Logo = () => (
    <div className="flex items-center gap-3">
      <div
        className="w-12 h-12 rounded-xl flex items-center justify-center shadow-lg"
        style={{
          background: "linear-gradient(135deg, #10b981 0%, #059669 50%, #047857 100%)",
          boxShadow: "0 4px 16px rgba(16, 185, 129, 0.3)",
        }}
      >
        <img
          src={process.env.PUBLIC_URL + "/favicon/favicon.ico"}
          className="h-7 w-7 drop-shadow-md"
          alt="Logo"
        />
      </div>
      <span
        className="font-bold text-2xl tracking-wide"
        style={{
          background: "linear-gradient(90deg, #059669, #10b981, #34d399)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }}
      >
        TAMA
      </span>
    </div>
  );

  // Mockup data
  const mockupUsers = [
    { name: "Maya Philips", followers: "4.5M users", color: "bg-pink-500", initial: "M" },
    { name: "Claire Writers", followers: "4M users", color: "bg-purple-500", initial: "C" },
    { name: "Austin Karter", followers: "3M users", color: "bg-blue-500", initial: "A" },
    { name: "Abram Daloda", followers: "2.5M users", color: "bg-emerald-500", initial: "A" },
  ];

  // Social login buttons data - all with consistent styling
  const socialLoginButtons = [
    { provider: "facebook", label: "Sign in with Facebook", Icon: FacebookIcon },
    { provider: "instagram", label: "Sign in with Instagram", Icon: InstagramIcon },
    { provider: "tiktok", label: "Sign in with Tiktok", Icon: TikTokIcon },
    { provider: "google", label: "Sign in with Google", Icon: GoogleIcon },
  ];

  // Signup Type Popup Component
  const SignupTypePopup = () => {
    if (!showSignupPopup) return null;

    return (
      <>
        {/* Backdrop with centered content */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center"
          onClick={() => setShowSignupPopup(false)}
        >
          {/* Popup Modal */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: 20 }}
            transition={{ type: "spring", damping: 25, stiffness: 300 }}
            className="w-[90%] max-w-md"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="bg-white rounded-2xl shadow-2xl p-6 sm:p-8 relative">
              {/* Close Button */}
              <button
                onClick={() => setShowSignupPopup(false)}
                className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 transition-colors"
              >
                <i className="fas fa-times text-gray-500"></i>
              </button>

              {/* Header */}
              <div className="text-center mb-6">
                <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2">Choose Account Type</h2>
                <p className="text-sm text-gray-500">Select how you want to sign up</p>
              </div>

              {/* Options */}
              <div className="flex flex-col gap-4">
                {/* Brand Option */}
             
                <button
                  // onClick={() => navigate("/account/pricing")}

                  onClick={() => {
                    setShowSignupPopup(false);
                    navigate('/account/signup?type=brand');
                  }}
                  className="group relative flex items-center gap-4 p-4 sm:p-5 bg-gradient-to-r from-emerald-50 to-green-50 border-2 border-emerald-200 rounded-xl hover:border-emerald-400 hover:shadow-lg transition-all duration-300"
                >
                  <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-xl bg-gradient-to-br from-emerald-500 to-green-600 flex items-center justify-center shadow-lg">
                    <i className="fas fa-building text-white text-lg sm:text-xl"></i>
                  </div>
                  <div className="flex-1 text-left">
                    <h3 className="font-semibold text-gray-900 text-base sm:text-lg mb-1">I am a Brand</h3>
                    <p className="text-xs sm:text-sm text-gray-500">Create campaigns and find influencers</p>
                  </div>
                  <i className="fas fa-chevron-right text-emerald-400 group-hover:translate-x-1 transition-transform"></i>
                </button>

                {/* Influencer Option */}
                <button
                  onClick={() => {
                    setShowSignupPopup(false);
                    navigate('/account/signup?type=influencer');
                  }}
                  className="group relative flex items-center gap-4 p-4 sm:p-5 bg-gradient-to-r from-pink-50 to-rose-50 border-2 border-pink-200 rounded-xl hover:border-pink-400 hover:shadow-lg transition-all duration-300"
                >
                  <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-xl bg-gradient-to-br from-pink-500 to-rose-600 flex items-center justify-center shadow-lg">
                    <i className="fas fa-star text-white text-lg sm:text-xl"></i>
                  </div>
                  <div className="flex-1 text-left">
                    <h3 className="font-semibold text-gray-900 text-base sm:text-lg mb-1">I am an Influencer</h3>
                    <p className="text-xs sm:text-sm text-gray-500">Showcase your talent and collaborate</p>
                  </div>
                  <i className="fas fa-chevron-right text-pink-400 group-hover:translate-x-1 transition-transform"></i>
                </button>
              </div>

              {/* Footer */}
              <p className="text-center text-xs text-gray-400 mt-6">
                Already have an account?{" "}
                <button
                  onClick={() => setShowSignupPopup(false)}
                  className="text-indigo-500 font-medium hover:underline"
                >
                  Sign In
                </button>
              </p>
            </div>
          </motion.div>
        </motion.div>
      </>
    );
  };

  return (
    <div className="flex min-h-screen font-sans">
      {/* Left Panel - Promotional Content - Desktop only */}
      <div className="hidden lg:flex flex-1 flex-col justify-center items-center py-8 px-4 bg-gradient-to-br from-blue-50 via-green-50 to-pink-50 lg:min-w-[50%] relative overflow-hidden">
        <div className="text-center max-w-[600px] z-10">
          {/* Heading */}
          <div className="flex items-start justify-center gap-3 mb-8">
            <span 
              className="text-4xl font-extrabold"
              style={{
                background: "linear-gradient(135deg, #10b981 0%, #059669 50%, #047857 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              #1
            </span>
            <h2 className="text-2xl font-bold text-gray-900 leading-tight text-left">
              End-to-End Influencer<br />Marketing Platform
            </h2>
          </div>

          {/* Dashboard Mockup */}
          <div className="bg-white rounded-2xl shadow-2xl p-6 mb-8 w-full max-w-[450px]">
            <div className="flex items-center justify-between mb-4 border-b border-gray-100 pb-4">
              <span className="text-sm font-semibold text-gray-700">Influencer Revenue Performance</span>
              <div className="flex gap-2">
                <span className="px-3 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-700">Reach</span>
                <span className="px-3 py-1 rounded-full text-xs font-medium bg-pink-100 text-pink-700">Engagement</span>
              </div>
            </div>
            <div className="flex flex-col gap-3">
              {mockupUsers.map((user, index) => (
                <div key={index} className="flex items-center justify-between p-3 rounded-lg bg-gray-50">
                  <div className="flex items-center gap-3">
                    <span className="font-semibold text-gray-400 mr-2">{index + 1}</span>
                    <div className={`w-9 h-9 rounded-full flex items-center justify-center text-white font-semibold text-sm ${user.color}`}>
                      {user.initial}
                    </div>
                    <span className="text-sm font-medium text-gray-900">{user.name}</span>
                  </div>
                  <span className="text-sm font-semibold text-gray-500">{user.followers}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Award-Winning Technology Section */}
          <div className="mt-10 w-full max-w-[600px]">
            <h3 className="text-lg font-semibold text-gray-800 mb-6 text-center">Award-Winning Technology</h3>
            <div className="flex items-center justify-between w-full">
              <img 
                src={process.env.PUBLIC_URL + "/images/trusted.png"} 
                alt="Trusted" 
                className="h-24 object-contain hover:scale-105 transition-transform duration-300"
              />
              <img 
                src={process.env.PUBLIC_URL + "/images/high_performance.png"} 
                alt="High Performance" 
                className="h-24 object-contain hover:scale-105 transition-transform duration-300"
              />
              <img 
                src={process.env.PUBLIC_URL + "/images/powerd_by_data.png"} 
                alt="Powered by Data" 
                className="h-24 object-contain hover:scale-105 transition-transform duration-300"
              />
              <img 
                src={process.env.PUBLIC_URL + "/images/recommended.png"} 
                alt="Recommended" 
                className="h-24 object-contain hover:scale-105 transition-transform duration-300"
              />
              <img 
                src={process.env.PUBLIC_URL + "/images/responsible_ai.png"} 
                alt="Responsible AI" 
                className="h-20 object-contain hover:scale-105 transition-transform duration-300"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Right Panel - Login Form - Full width on mobile/tablet */}
      <div className="w-full lg:flex-1 flex flex-col justify-center items-center py-6 px-4 sm:py-8 sm:px-6 lg:py-12 lg:px-8 bg-white lg:min-w-[50%] min-h-screen lg:min-h-0">
        {isLinkVerified && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4 }}
            className="w-full max-w-[420px]"
          >
            {/* Logo */}
            <div className="flex items-center justify-center mb-8">
              <Logo />
            </div>

            {/* Verification Message */}
            {verificationMessage && (
              <div className="bg-green-100 text-green-800 px-4 py-3 rounded-lg mb-4 text-sm text-center">
                <strong>{verificationMessage}</strong>
              </div>
            )}

            {isLoginWithEmail ? (
              /* Email Login Form */
              <>
                {/* Back Button */}
                <button 
                  onClick={() => setIsLoginWithEmail(false)}
                  className="flex items-center gap-2 text-xs sm:text-sm text-gray-500 hover:text-gray-700 mb-4 sm:mb-6 transition-colors"
                >
                  <i className="fas fa-arrow-left"></i>
                  Back
                </button>

                {/* Heading */}
                <h1 className="text-xl sm:text-2xl font-semibold text-gray-900 mb-4 sm:mb-8 text-center">
                  Login Into Your Account
                </h1>

                {/* Email Input */}
                <div className="mb-3 sm:mb-5">
                  <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1.5 sm:mb-2">Email</label>
                  <input
                    type="email"
                    placeholder="Your email address"
                    value={form.email}
                    onChange={setInput("email")}
                    className={`w-full px-3 sm:px-4 py-2.5 sm:py-3.5 text-sm sm:text-base border rounded-lg outline-none transition-all duration-200 bg-white focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100 ${
                      error && !form.email ? "border-red-500" : "border-gray-200"
                    }`}
                    autoFocus
                  />
                  {error && !form.email && (
                    <span className="text-red-500 text-xs mt-1 block">Please enter Email</span>
                  )}
                </div>

                {/* Password Input */}
                <div className="mb-3 sm:mb-5">
                  <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1.5 sm:mb-2">Password</label>
                  <div className="relative">
                    <input
                      type={showPassword ? "text" : "password"}
                      placeholder="Your password"
                      value={form.password}
                      onChange={setInput("password")}
                      className={`w-full px-3 sm:px-4 py-2.5 sm:py-3.5 pr-10 sm:pr-12 text-sm sm:text-base border rounded-lg outline-none transition-all duration-200 bg-white focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100 ${
                        error && !form.password ? "border-red-500" : "border-gray-200"
                      }`}
                    />
                    <i
                      className={`fas ${showPassword ? "fa-eye" : "fa-eye-slash"} absolute right-3 sm:right-4 top-1/2 -translate-y-1/2 cursor-pointer text-gray-400 hover:text-gray-600 text-sm sm:text-base`}
                      onClick={() => setShowPassword(!showPassword)}
                    ></i>
                  </div>
                  {error && !form.password && (
                    <span className="text-red-500 text-xs mt-1 block">Please enter Password</span>
                  )}
                </div>

                {/* Forgot Password */}
                <div className="text-right mb-4 sm:mb-6">
                  <Link to="/account/forgot-pass" className="text-xs sm:text-sm text-gray-500 hover:text-gray-700 transition-colors">
                    Forgot Password?
                  </Link>
                </div>

                {/* Login Button */}
                <button
                  onClick={loginValidation}
                  disabled={loading}
                  className={`w-full py-2.5 sm:py-3.5 text-sm sm:text-base font-semibold text-white rounded-full transition-all duration-200 mb-4 sm:mb-6 ${
                    loading
                      ? "bg-gray-400 cursor-not-allowed"
                      : "bg-gray-900 hover:bg-gray-800 active:scale-[0.98]"
                  }`}
                >
                  {loading ? "LOGGING IN..." : "LOGIN"}
                </button>
              </>
            ) : (
              /* Social Login Options */
              <>
                {/* Heading */}
                <h1 className="text-xl sm:text-2xl font-semibold text-gray-900 mb-1 sm:mb-2">
                  Login
                </h1>
                <p className="text-gray-600 mb-4 sm:mb-8 text-sm sm:text-base">How would you like to sign in?</p>

                {/* Social Login Buttons */}
                <div className="flex flex-col gap-2 sm:gap-4">
                  {socialLoginButtons.map(({ provider, label, Icon }) => (
                    <button
                      key={provider}
                      onClick={() => socialLogin(provider)}
                      className="w-full py-2.5 sm:py-4 text-sm sm:text-base font-medium bg-white border border-gray-200 rounded-lg sm:rounded-xl flex items-center justify-center gap-2 sm:gap-3 transition-all duration-200 hover:bg-gray-50 hover:border-gray-300"
                    >
                      <Icon />
                      {label}
                    </button>
                  ))}

                  {/* Email Login Button */}
                  <button
                    onClick={() => setIsLoginWithEmail(true)}
                    className="w-full py-2.5 sm:py-4 text-sm sm:text-base font-medium bg-white border border-gray-200 rounded-lg sm:rounded-xl flex items-center justify-center gap-2 sm:gap-3 transition-all duration-200 hover:bg-gray-50 hover:border-gray-300"
                  >
                    <EmailIcon />
                    Sign in with Email
                  </button>
                </div>
              </>
            )}

            {/* Sign Up Link */}
            <p className="text-center text-xs sm:text-sm text-gray-500 mt-4 sm:mt-8">
              Don't have an account?{" "}
              <button
                onClick={() => setShowSignupPopup(true)}
                className="text-indigo-500 font-medium hover:text-indigo-600"
              >
                Sign Up
              </button>
            </p>

            {/* Footer */}
            <div className="border-t border-gray-100 mt-4 sm:mt-8 pt-4 sm:pt-6">
              <div className="flex flex-col sm:flex-row items-center justify-between gap-3 sm:gap-0">
                <div className="flex items-center gap-2 sm:gap-4 text-xs sm:text-sm text-gray-500">
                  <span>© 2026</span>
                  <a href="https://tamayou.com/privacy" target="_blank" rel="noopener noreferrer" className="hover:text-gray-700">Privacy Policy</a>
                  <a href="https://tamayou.com/terms" target="_blank" rel="noopener noreferrer" className="hover:text-gray-700">Terms of Service</a>
                </div>
                <div className="flex items-center gap-4">
                  <a href="https://www.facebook.com/tamayouhub" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-gray-700">
                    <i className="fab fa-facebook-f"></i>
                  </a>
                  <a href="https://www.instagram.com/tamayouhub/" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-gray-700">
                    <i className="fab fa-instagram"></i>
                  </a>
                  <a href="https://x.com/tamayou" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-gray-700">
                    <i className="fab fa-x-twitter"></i>
                  </a>
                </div>
              </div>
            </div>
          </motion.div>
        )}
      </div>

      {/* Toast Messages */}
      {toastList.length > 0 && (
        <Toast list={toastList} setList={setToastList} />
      )}

      {/* Signup Type Selection Popup */}
      <SignupTypePopup />
    </div>
  );
}
